import { Color, DefaultValue, FontSize, getShadow, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const FolderPathItemCurrent = styled.span`
  color: ${Color.Black};
  font-size: ${FontSize.TextBodyMD};
`

export const FolderPathItemClickable = styled.span`
  color: ${Color.Black};
  font-size: ${FontSize.TextBodyMD};
  cursor: pointer;
`

export const BreadcrumbsWrapper = styled.div`
  max-width: 100%;
  overflow: hidden;
`

export const CollapsedCrumbsTrigger = styled.button`
  padding: ${Spacing.S2} ${Spacing.S4};
  border-radius: ${DefaultValue.BorderRadius};
  color: ${Color.Black};
  cursor: pointer;
  all: unset;

  &:hover {
    background-color: ${Color.Grey50};
  }
`

export const CollapsedCrumbsMenu = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${Spacing.S4} 0;
  border-radius: ${DefaultValue.BorderRadius};
  background: ${Color.White};
  ${getShadow('raisedStrong')};
`

export const CollapsedCrumbsMenuItem = styled.button`
  padding: ${Spacing.S8} ${Spacing.S12};
  color: ${Color.Black};
  white-space: nowrap;
  cursor: pointer;
  all: unset;

  &:hover {
    background-color: ${Color.Grey50};
  }
`
